import React from "react";
import { cn } from "@/lib/utils";

/**
 * Eyebrow — small uppercase tag with a soft glow dot.
 * Used above section headers to add structure.
 */
const Eyebrow = ({ children, icon: Icon, className = "" }) => (
  <span className={cn("eyebrow", className)}>
    {Icon ? <Icon className="w-3.5 h-3.5" /> : <span className="dot" />}
    <span>{children}</span>
  </span>
);

export default Eyebrow;
